import R from 'ramda'

// Mapping form actions to widget actions

import {
  isGoogleSheetAppendFormAction,
  convertGoogleSheetAppendFormActionToWidgetAction
} from '../common/form-to-widget/google-sheet-append'

import {
  isInstagramCommentReplyFormAction,
  convertFormCommentToWidget
} from './form-to-widget/instagram-comment-reply'

import {
  isIgDmFormAction,
  convertIgFormDmToWidgetDm
} from './form-to-widget/send-instagram-dm'

// Mapping form widget actions to form actions

import {
  isGoogleSheetAppendWidgetAction,
  convertGoogleSheetAppendWidgetActionToFormAction
} from '../common/widget-to-form/google-sheet-append'

import {
  isCommentReplyWidgetAction,
  convertInstagramCommentToFormComment
} from './widget-to-form/instagram-comment-reply'

import {
  isIgDmWidgetAction,
  convertIgWidgetDmToFormDm
} from './widget-to-form/send-instagram-dm'

const mapInstagramFormActionsToWidgetActions = R.map(
  R.cond([
    [
      isGoogleSheetAppendFormAction,
      convertGoogleSheetAppendFormActionToWidgetAction
    ],
    [isInstagramCommentReplyFormAction, convertFormCommentToWidget],
    [isIgDmFormAction, convertIgFormDmToWidgetDm],
    [R.T, R.identity]
  ])
)

const mapInstagramWidgetActionsToFormActions = R.map(
  R.cond([
    [
      isGoogleSheetAppendWidgetAction,
      convertGoogleSheetAppendWidgetActionToFormAction
    ],
    [isCommentReplyWidgetAction, convertInstagramCommentToFormComment],
    [isIgDmWidgetAction, convertIgWidgetDmToFormDm],
    [R.T, R.identity]
  ])
)

export {
  mapInstagramFormActionsToWidgetActions,
  mapInstagramWidgetActionsToFormActions
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/instagram/index.js